<div class="main">
  @if (selectedIndex() === 0) {
    <app-page-greeting />
  }
  <div class="right-hlf">
    <div class="right-hlf-header">
      @if (selectedIndex() > 0) {
        <img src="./assets/logo-210.svg" class="logo">
      }
      <citadel-wizard-steps [steps]="steps()" [selectedIndex]="selectedIndex()" />
    </div>
    <div class="content">
      <router-outlet />
    </div>
  </div>
</div>
